import { ImageField, Panel, TextField } from "./fields";

export const BrandingTab = ({ brand, set }) => (
  <div className="space-y-6" data-testid="admin-branding-tab">
    <Panel title="Logo & name" hint="Shown in the header, footer and on the sign-in page.">
      <div className="grid gap-5 md:grid-cols-2">
        <div className="md:col-span-2"><ImageField label="Logo" value={brand.logo_url} onChange={(v) => set({ logo_url: v })} testid="brand-logo" /></div>
        <TextField label="Hotel name" value={brand.name} onChange={(v) => set({ name: v })} testid="brand-name-input" />
        <TextField label="Tagline" value={brand.tagline} onChange={(v) => set({ tagline: v })} testid="brand-tagline-input" />
      </div>
    </Panel>
    <Panel title="Contact & footer">
      <div className="grid gap-5 md:grid-cols-2">
        <TextField label="Phone" value={brand.phone} onChange={(v) => set({ phone: v })} testid="brand-phone-input" />
        <TextField label="Email" value={brand.email} onChange={(v) => set({ email: v })} testid="brand-email-input" />
        <div className="md:col-span-2"><TextField label="Address" value={brand.address} onChange={(v) => set({ address: v })} testid="brand-address-input" /></div>
        <div className="md:col-span-2"><TextField label="Footer text" value={brand.footer_text} onChange={(v) => set({ footer_text: v })} testid="brand-footer-input" /></div>
      </div>
    </Panel>
  </div>
);
